export default __webpack_public_path__ + "f03ec48adfb71cc366599bbde70e2de9.svg";